module.exports = __webpack_public_path__ + "static/media/choose-account.3b16d421.jpg";